import React, { useEffect, useState } from "react";
import { Button, Col, Row, Form } from "react-bootstrap";

import { toast } from "react-toastify";
import {
  FinanceDetailsInterface,
  RegistrationIds,
} from "../../../../assets/interface/primeSharkWebsite_interface";
import WebService from "../../../../Services/WebService";
import CompoLoader from "../../../ComponentLoader/CompoLoader";
import ErrorComponent from "../../../Common/ErrorComponent";
import CurrencyInputField from "../../../Common/CurrencyInput/CurrencyInputField";
import CommonScrollbar from "../../../Common/ScrollBar/CommonScrollbar";
import Calender from "../../../Common/Calender/Calender";
import { isDate } from "moment";
import DatePicker from "react-datepicker";
import { FaCalendarAlt } from "react-icons/fa";
import RequiredLabel from "../../../Common/RequiredLabel/RequiredLabel";
import SuccessPopup from "../../SuccessPopup";
import { isWarning } from "../../Helper";
import { getProfileJourneyInfo, dropdownApiNewcall, validateAmount, getConvertedRangeLimits } from "../../../../Services/CommonFunction";
import { useDispatch } from "react-redux";
import Select from "react-dropdown-select";
import { DROPDOWNTYPES } from "../../../../assets/constants/constants";
import HelperService from "../../../../Services/HelperService";
import { Label } from "../../../Common/Label/Label";


interface PropsData {
  impIds: RegistrationIds;
  handleNext: any;
  from?: string;
  fields_to_improve?: any;
}

const FinanceDetails = ({
  impIds,
  handleNext,
  from,
  fields_to_improve,
}: PropsData) => {
  const [financeDetails, setFinanceDetails] = useState<any>(
    {
      generated_revenue: "",
      projected_revenue: "",
      financial_from_year: null,
      financial_to_year: null,
      capital_offer_type: "",
      funding_goal_amount: "",
      investment_round: "",
      minimum_acceptable_investment: "",
      use_of_funds: "",
      use_of_funds_other: "",
      expected_roi: "",
      ebitda: "",
      current_annual_revenue: "",
      total_investment_raised_date: "",
      investment_valuation: "",
      usd_rate: 1,
      preferred_currency: ""
    },
  );
  const [dropdownData, setDropdownData] = useState<Record<string, { label: string; value: string }[]>>({});
  const [errorFlag, setErrorFlag] = useState(false);
  const [checked1, setChecked1] = useState(false);
  const [checked2, setChecked2] = useState(false);
  const [loader, setLoader] = useState(false);
  const [show, setShow] = useState(false);
  let dispatch = useDispatch();
  const getYearString = (val: any) => {
    if (!val) return "";
    const date = new Date(val);
    if (!isNaN(date.getTime())) {
      return date.getFullYear().toString();
    }
    const match = String(val).match(/^\d{4}/);
    return match ? match[0] : "";
  };

  const CustomInput = React.forwardRef(({ onClick }: any, ref: any) => {
    const fromYear = getYearString(financeDetails?.financial_from_year);
    const toYear = getYearString(financeDetails?.financial_to_year);
    return (
      <>
        <div className="input-group w-100" onClick={onClick} ref={ref}>
          <input
            type="text"
            value={fromYear ? `${fromYear}-${Number(fromYear) + 1}` : ""}
            className={
              isWarning(fields_to_improve, "financial_from_year")
                ? "warning-field form-control text-center cursor-pointer"
                : "form-control text-center cursor-pointer"
            }
            readOnly
            placeholder="Select year"
            onKeyDown={(e) => {
              if (e.key === "Backspace") {
                setFinanceDetails((prev: any) => ({
                  ...prev,
                  financial_from_year: null,
                  financial_to_year: null,
                }));
              }
            }}
          />
          <span className="input-group-text bg-white">
            <FaCalendarAlt />
          </span>
        </div>
      </>
    );
  });
  CustomInput.displayName = "CustomInput";
  const [apiCallTriggered, setAPICallTriggered] = useState(false);

  useEffect(() => {
    if (impIds?.business_uuid) {
      handleGetFinanceDetails();
    }
    if (from === "REVIEW" || from === "FROM_PROFILE_ANALYSIS") {
      loadDropdowns();
    }
  }, []);

  async function loadDropdowns() {
    try {
      const typesToLoad = [
        DROPDOWNTYPES.INVESTMENT_ROUND,
        DROPDOWNTYPES.CAPITAL_OFFER_TYPE,
        DROPDOWNTYPES.USE_OF_FUNDS,
        DROPDOWNTYPES.CURRENT_ANNUAL_REVENUE,
        DROPDOWNTYPES.FUNDING_GOAL,
      ];
      const res = await dropdownApiNewcall(
        impIds?.account_type?.toLocaleLowerCase(),
        typesToLoad,
      );
      const formattedData: Record<string, { label: string; value: string }[]> = {};

      typesToLoad.forEach((type) => {
        const items = res[type];
        if (Array.isArray(items)) {
          formattedData[type] = items.map((item: any) => ({
            label: item.title,
            value: item.title,
          }));
        }
      });

      setDropdownData(formattedData);
    } catch (error) { }
  }

  const handleChange = (name: string, value: string) => {
    setFinanceDetails(
      (prevFinanceDetails: any) => ({
        ...prevFinanceDetails,
        [name]: value,
      }),
    );
  };

  const handleArrayValueChange = (value: any[], key: string) => {
    setFinanceDetails((prevDetails: any) => ({
      ...prevDetails,
      [key]: Array.isArray(value)
        ? value.map((item: any) => ({
          title: item?.value,
          other: item?.other || "",
        }))
        : value,
    }));
  };

  const [issueInMinAcceptableAmount, setIssueInMinAcceptableAmount] = useState(false);

  useEffect(() => {
    const minimumAcceptableInvestment = Number(
      financeDetails?.minimum_acceptable_investment,
    );
    const fundingGoalAmount = financeDetails?.funding_goal_amount;

    if (minimumAcceptableInvestment > 0) {
      const isValid = validateAmount(
        minimumAcceptableInvestment,
        fundingGoalAmount,
        financeDetails?.usd_rate || 1,
      );

      if (!isValid) setIssueInMinAcceptableAmount(true);
      else setIssueInMinAcceptableAmount(false);
    } else {
      setIssueInMinAcceptableAmount(false);
    }
  }, [
    financeDetails?.minimum_acceptable_investment,
    financeDetails?.funding_goal_amount,
    financeDetails?.usd_rate,
  ]);

  const skipButtonClicked = false;

  useEffect(() => {
    if (from === "FROM_PROFILE_ANALYSIS") {
      setChecked1(true);
      setChecked2(true);
    }
  }, [from]);

  const handleGetFinanceDetails = () => {
    setLoader(true);
    WebService.getAPI({
      action: `get-business/investment/${impIds?.business_uuid}`,
      body: null,
      isShowError: true,
    })
      .then((res: any) => {
        if (res?.status) {
          let info = res?.info;
          const fromYear = info?.financial_from_year ? getYearString(info?.financial_from_year) : "";
          const toYear = info?.financial_to_year ? getYearString(info?.financial_to_year) : (fromYear ? `${Number(fromYear) + 1}` : "");
          const yearRange = info?.financial_year_range || (fromYear ? `${fromYear}-${toYear}` : "");

          setFinanceDetails((prevFinance: any) => ({
            ...prevFinance,
            ...info,
            generated_revenue: info?.generated_revenue ?? "",
            projected_revenue: info?.projected_revenue ?? "",
            financial_from_year: fromYear || info?.financial_from_year || null,
            financial_to_year: toYear || info?.financial_to_year || null,
            financial_year_range: yearRange,
            capital_offer_type: info?.capital_offer_type ?? "",
            funding_goal_amount: info?.funding_goal_amount ?? "",
            investment_round: info?.investment_round ?? "",
            minimum_acceptable_investment: info?.minimum_acceptable_investment ?? "",
            use_of_funds: info?.use_of_funds ?? "",
            use_of_funds_other: info?.use_of_funds_other ?? "",
            expected_roi: info?.expected_roi ?? "",
            ebitda: info?.ebitda ?? "",
            current_annual_revenue: info?.current_annual_revenue ?? "",
            total_investment_raised_date: info?.total_investment_raised_date ?? "",
            investment_valuation: info?.investment_valuation ?? "",
            usd_rate: info?.users?.usd_rate,
            inverse_usd_rate: info?.users?.inverse_usd_rate,
            preferred_currency: info?.users?.preferred_currency,
          }));
        }
      })
      .catch((error: any) => {
        return false;
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const handleContinue = (flag: boolean) => {
    let f1 = isDate(financeDetails?.financial_from_year)
      ? financeDetails?.financial_from_year?.getFullYear()
      : getYearString(financeDetails?.financial_from_year);
    let f2 = isDate(financeDetails?.financial_to_year)
      ? financeDetails?.financial_to_year?.getFullYear()
      : getYearString(financeDetails?.financial_to_year);

    if (!f1 && financeDetails?.financial_year_range) {
      const parts = financeDetails.financial_year_range.split("-");
      f1 = parts[0];
      f2 = parts[1] || `${Number(parts[0]) + 1}`;
    } else if (f1 && !f2) {
      f2 = `${Number(f1) + 1}`;
    }

    if ((!checked1 && from !== "REVIEW") || (!checked2 && from !== "REVIEW")) {
      setErrorFlag(true);
      return;
    } else {
      setErrorFlag(false);
      let obj = {
        ...financeDetails,
        financial_from_year: f1 ?? null,
        financial_to_year: f2 ?? null,
      };
      handleSaveFinanceDetailApiCall(obj, flag);
    }
  };
  const handleSaveFinanceDetailApiCall = (obj: any, flag: boolean) => {
    if (flag) WebService.addLoader("skip_finance_details");
    else WebService.addLoader("save_finance_details");
    setAPICallTriggered(true);

    if (from === "REVIEW" || from === "FROM_PROFILE_ANALYSIS") {
      return WebService.putAPI({
        action: `set-finance/investment/${impIds?.business_uuid}`,
        body: obj,
        isShowError: false,
      })
        .then((res: any) => {
          if (res?.status) {
            toast.success(res?.message || "Finance details updated successfully");
            getProfileJourneyInfo(
              impIds?.account_type?.toLocaleLowerCase(),
              impIds?.business_uuid,
              dispatch,
            );
            handleNext(res);
          } else {
            toast.error(res?.message || "Failed to update details");
          }
        })
        .catch((error: any) => {
          toast.error(error?.response?.data?.message || "Something went wrong");
          return error;
        })
        .finally(() => {
          if (flag) WebService.removeLoader("skip_finance_details");
          else WebService.removeLoader("save_finance_details");
          setAPICallTriggered(false);
        });
    } else {
      // Normal signup flow: only call set-finance API
      return WebService.putAPI({
        action: `set-finance/investment/${impIds?.business_uuid}`,
        body: obj,
        isShowError: false,
      })
        .then((res: any) => {
          if (res?.status) {
            setShow(true);
            handleNext(res);
          } else {
            toast.error(res.message);
          }
        })
        .catch((error: any) => {
          toast.error(error?.response?.data?.message);
          return error;
        })
        .finally(() => {
          if (flag) WebService.removeLoader("skip_finance_details");
          else WebService.removeLoader("save_finance_details");
          setAPICallTriggered(false);
        });
    }
  };
  const handleChangeCurrency = (type: string, value: any) => {
    setFinanceDetails((prevFinanceDetails: any) => ({
      ...prevFinanceDetails,
      [type]: value,
    }));
  };
  const handleYearChange = (date: Date | null) => {
    if (date) {
      setFinanceDetails((prev: any) => ({
        ...prev,
        financial_from_year: date,
        financial_to_year: new Date(
          new Date(date).setFullYear(new Date(date).getFullYear() + 1),
        ),
      }));
    }
  };
  const handleYearChange1 = (date: Date | null) => {
    return;
    if (date) {
      setFinanceDetails((prev: any) => ({
        ...prev,
        financial_to_year: date,
      }));
    }
  };
  return (
    <div className="login-form w-100 px-0 position-relative">
      {loader ? <CompoLoader /> : null}

      <h4>Finance</h4>
      <p>Please finance details</p>
      <CommonScrollbar height={"60vh"}>
        <>
          <div className="mb-3 w-50">
            <div>
              <RequiredLabel isRequired={false}>Financial Year</RequiredLabel>
            </div>
            {/* Fiscal year dropdown, e.g., "2015-2016" */}
            <Select
              placeholder="Select Fiscal Year"
              clearable={false}
              className={
                isWarning(fields_to_improve, "financial_year_range") ||
                  isWarning(fields_to_improve, "financial_from_year")
                  ? "warning-field "
                  : ""
              }
              options={Array.from({ length: new Date().getFullYear() - 1999 }, (_, i) => {
                const start = 2000 + i;
                return { label: `${start}-${start + 1}`, value: `${start}-${start + 1}` };
              })}
              onChange={(values: any) => {
                const val = values?.[0]?.value || "";
                if (val) {
                  const parts = val.split("-");
                  const fromY = parts[0] || "";
                  const toY = parts[1] || (fromY ? `${Number(fromY) + 1}` : "");
                  setFinanceDetails((prev: any) => ({
                    ...prev,
                    financial_year_range: val,
                    financial_from_year: fromY,
                    financial_to_year: toY,
                  }));
                } else {
                  setFinanceDetails((prev: any) => ({
                    ...prev,
                    financial_year_range: "",
                    financial_from_year: null,
                    financial_to_year: null,
                  }));
                }
              }}
              labelField="label"
              valueField="value"
              name="financial_year_range"
              values={financeDetails.financial_year_range ? [{ label: financeDetails.financial_year_range, value: financeDetails.financial_year_range }] : []}
            />
          </div>
          <div className="mb-2">
            <RequiredLabel isRequired={false}>Generated Revenue</RequiredLabel>

            <CurrencyInputField
              placeHolder="Enter Generated Revenue"
              id="generated_revenue"
              prefix="$"
              suffix=""
              value={financeDetails?.generated_revenue}
              setValue={(value: string) => {
                handleChangeCurrency("generated_revenue", value);
              }}
              className={
                isWarning(fields_to_improve, "generated_revenue")
                  ? "warning-field "
                  : ""
              }
            />
          </div>
          <div className="mb-4">
            <RequiredLabel isRequired={false}>Projected Revenue</RequiredLabel>
            <CurrencyInputField
              placeHolder="Enter Estimated Revenue"
              id="projected_revenue"
              prefix="$"
              suffix=""
              value={financeDetails?.projected_revenue}
              setValue={(value: string) => {
                handleChangeCurrency("projected_revenue", value);
              }}
              className={
                isWarning(fields_to_improve, "projected_revenue")
                  ? "warning-field "
                  : ""
              }
            />
            {/* <ErrorComponent
              title="Please enter estimated revenue"
              flag={errorFlag}
              isArray={false}
              data={financeDetails?.projected_revenue}
            /> */}
          </div>
          {from && from === "REVIEW" ? null : (
            <div>
              <div className="form-check mb-0">
                <input
                  className={
                    errorFlag && !checked1
                      ? "custom-checkbox form-check-input"
                      : "form-check-input"
                  }
                  type="checkbox"
                  value=""
                  id="flexCheckDefault"
                  checked={checked1}
                  onChange={() => setChecked1(!checked1)}
                />
                <label
                  className="form-check-label pb-0"
                  htmlFor="flexCheckDefault"
                >
                  <span className="checkbox-title">
                    {" "}
                    I have read and agree to the{" "}
                    <a
                      href="https://theprimeshark.com/terms-of-use/"
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={(e) => e.stopPropagation()}
                    >
                      terms and conditions
                    </a>
                  </span>
                </label>
              </div>
            </div>
          )}
          {from && from === "REVIEW" ? null : (
            <div>
              <div className="form-check mb-4">
                <input
                  className={
                    errorFlag && !checked2
                      ? "custom-checkbox form-check-input"
                      : "form-check-input"
                  }
                  type="checkbox"
                  value=""
                  id="flexCheckDefault1"
                  checked={checked2}
                  onChange={() => setChecked2(!checked2)}
                />
                <label
                  className="form-check-label pb-0"
                  htmlFor="flexCheckDefault1"
                >
                  <span className="checkbox-title">
                    {" "}
                    I give my consent to the processing of my personal data,
                    including for AI matchmaking, in line with the{" "}
                    <a
                      href="https://theprimeshark.com/privacy-policy/"
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={(e) => e.stopPropagation()}
                    >
                      Privacy Policy
                    </a>.
                  </span>
                </label>
              </div>
            </div>
          )}
          <div className="mb-2 d-flex gap-2">
            <Button
              className={
                from === "REVIEW" || from === "FROM_PROFILE_ANALYSIS"
                  ? "btn btn-primary w-100"
                  : "btn btn-primary w-50"
              }
              disabled={apiCallTriggered}
              type="button"
              id="save_finance_details"
              onClick={() => handleContinue(false)}
            >
              {from && from === "REVIEW" ? "Save" : "Continue"}
            </Button>
            {from !== "REVIEW" && from !== "FROM_PROFILE_ANALYSIS" && (
              <Button
                className="btn btn-secondary w-50"
                type="button"
                id="skip_finance_details"
                onClick={() => {
                  handleContinue(true);
                }}
                disabled={apiCallTriggered}
              >
                Skip
              </Button>
            )}
          </div>
        </>
      </CommonScrollbar>
      {show && (
        <SuccessPopup
          show={show}
          msg="Capital bridge profile registered successfully!"
          id="capital_bridge_id"
        />
      )}
    </div>
  );
};
export default FinanceDetails;
